import { Fragment, useContext, useRef, useState } from "react";
import { CartContext } from "../../../CartContext";
import Modal from "../../Layout/Modal";
import classes from "./profileForm.module.css";

export default function ProfileForm(props) {
  const [imgUpload, setImg] = useState(null);
  const cartCtx = useContext(CartContext);
  const pictureRef = useRef();
  const nameRef = useRef();
  const emailRef = useRef();

  const imageLoader = (e) => {
    setImg(e.target.files[0]);
  };

  const profileUpdateHandler = (e) => {
    e.preventDefault();
    const enteredName = nameRef.current.value;
    const enteredEmail = emailRef.current.value;

    if (imgUpload === "" || enteredName === "" || enteredEmail === "") {
      return;
    }

    const profileData = {
      profilePicture: imgUpload,
      name: enteredName,
      email: enteredEmail,
    };

    fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:update?key=AIzaSyCilTl0dDYnSgzy29JLmkLF857SH-WWEx0",
      {
        method: "POST",
        body: JSON.stringify({
          idToken: cartCtx.token,
          displayName: profileData.name,
          photoUrl: URL.createObjectURL(profileData.profilePicture),
          returnSecureToken: true,
          headers: {
            "Content-Type": "application/json",
          },
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => console.log(data));

    props.setProfileForm(false);
  };

  const hideProfileForm = () => {
    props.setProfileForm(false);
  };

  return (
    <Modal>
      <section className={classes.section}>
        <h1>Update Your Profile</h1>
        <hr />
        <form onSubmit={profileUpdateHandler}>
          <div className={classes.profile}>
            <label htmlFor="picture">Profile Picture</label>
            <input
              onChange={imageLoader}
              accept="image/png, image/jpg"
              className={classes.picture}
              id="picture"
              type="file"
            />
          </div>
          <div className={classes.profile}>
            <label htmlFor="name">Enter Name</label>
            <input ref={nameRef} type="text" id="name" />
          </div>
          <div className={classes.profile}>
            <label htmlFor="email">Enter Email</label>
            <input ref={emailRef} type="email" id="email" />
          </div>

          <div className={classes.action}>
            <button>Update</button>
            <button
              onClick={hideProfileForm}
              className={classes.cancel}
              type="button"
            >
              Cancel
            </button>
          </div>
        </form>
      </section>
    </Modal>
  );
}
